import { createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-10cb17c3")

_pushScopeId("data-v-10cb17c3")
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = {
  class: "form-horizontal",
  action: "",
  method: "get"
}
const _hoisted_5 = { class: "form-group row" }
const _hoisted_6 = { class: "col-md-2" }
const _hoisted_7 = /*#__PURE__*/_createVNode("label", null, "신고대상유형", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("option", {
  value: "",
  selected: ""
}, "전체", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("option", { value: "선상낚시" }, "선상낚시", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("option", { value: "낚시터" }, "낚시터", -1)
const _hoisted_11 = { class: "col-md-2" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", null, "신고사유", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("option", {
  value: "",
  selected: ""
}, "전체", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("option", { value: "공지" }, "공지", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("option", { value: "이벤트" }, "이벤트", -1)
const _hoisted_16 = { class: "col-md-2" }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", null, "신고상태", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("option", {
  value: "",
  selected: ""
}, "전체", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("option", { value: "review" }, "심사중", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("option", { value: "blind" }, "숨김", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("option", { value: "reject" }, "반려", -1)
const _hoisted_22 = { class: "col-md-2" }
const _hoisted_23 = { class: "search-btn" }
const _hoisted_24 = { class: "table-responsive" }
const _hoisted_25 = { class: "table table-bordered table-striped table-md table-hover" }
const _hoisted_26 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "text-center" }, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "신고대상유형"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "신고사유"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "신고상태"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "신고일시")
  ])
], -1)
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = {
  key: 0,
  class: "text-left"
}
const _hoisted_29 = {
  key: 1,
  class: "text-left"
}
const _hoisted_30 = {
  key: 2,
  class: "text-left"
}
const _hoisted_31 = {
  key: 3,
  class: "text-left"
}
const _hoisted_32 = {
  key: 4,
  class: "text-left"
}
const _hoisted_33 = {
  key: 5,
  class: "text-left"
}
const _hoisted_34 = {
  key: 6,
  class: "text-left"
}
const _hoisted_35 = {
  key: 7,
  class: "text-left"
}
const _hoisted_36 = {
  key: 0,
  class: "badge bg-success text-white btn-sm"
}
const _hoisted_37 = {
  key: 1,
  class: "badge bg-danger text-white btn-sm"
}
const _hoisted_38 = {
  key: 2,
  class: "badge bg-primary text-white btn-sm"
}
const _hoisted_39 = { class: "pagination justify-content-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: ["card", { loading: _ctx.loading }]
      }, [
        _createVNode("div", _hoisted_3, [
          _createVNode("form", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _hoisted_7,
                _withDirectives(_createVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.reporter_id = $event)),
                  required: ""
                }, [
                  _hoisted_8,
                  _hoisted_9,
                  _hoisted_10
                ], 512), [
                  [_vModelSelect, _ctx.filter.reporter_id]
                ])
              ]),
              _createVNode("div", _hoisted_11, [
                _hoisted_12,
                _withDirectives(_createVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter.target_user_id = $event)),
                  required: ""
                }, [
                  _hoisted_13,
                  _hoisted_14,
                  _hoisted_15
                ], 512), [
                  [_vModelSelect, _ctx.filter.target_user_id]
                ])
              ]),
              _createVNode("div", _hoisted_16, [
                _hoisted_17,
                _withDirectives(_createVNode("select", {
                  class: "form-control",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter.report_state = $event)),
                  required: ""
                }, [
                  _hoisted_18,
                  _hoisted_19,
                  _hoisted_20,
                  _hoisted_21
                ], 512), [
                  [_vModelSelect, _ctx.filter.report_state]
                ])
              ]),
              _createVNode("div", _hoisted_22, [
                _createVNode("div", _hoisted_23, [
                  _createVNode("button", {
                    class: "btn btn-primary align-bottom",
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.searchHandler && _ctx.searchHandler(...args)))
                  }, " 검색 "),
                  _createVNode("button", {
                    class: "btn btn-danger align-bottom ml-2",
                    type: "button",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.resetFilter && _ctx.resetFilter(...args)))
                  }, " 초기화 ")
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_24, [
            _createVNode("table", _hoisted_25, [
              _hoisted_26,
              _createVNode("tbody", _hoisted_27, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userReports, (report) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: report.id,
                    onClick: ($event: any) => (_ctx.editRecord(report.id))
                  }, [
                    (report.type === 'fishinggram')
                      ? (_openBlock(), _createBlock("td", _hoisted_28, " 피싱그램 "))
                      : (report.type === 'user')
                        ? (_openBlock(), _createBlock("td", _hoisted_29, " 사용자 "))
                        : (_openBlock(), _createBlock("td", _hoisted_30, "피싱그램-댓글")),
                    (report.inappropriate === 'fishinggram')
                      ? (_openBlock(), _createBlock("td", _hoisted_31, " 부적절한 콘텐츠 게시 "))
                      : (report.reason_type === 'impostor')
                        ? (_openBlock(), _createBlock("td", _hoisted_32, " 타인사칭 "))
                        : (report.reason_type === 'spam')
                          ? (_openBlock(), _createBlock("td", _hoisted_33, " 스팸계정 "))
                          : (report.type !== 'user')
                            ? (_openBlock(), _createBlock("td", _hoisted_34, " - "))
                            : (_openBlock(), _createBlock("td", _hoisted_35, "기타 - " + _toDisplayString(report.remark), 1)),
                    _createVNode("td", null, [
                      (report.report_state === 'review')
                        ? (_openBlock(), _createBlock("span", _hoisted_36, "심사중"))
                        : (report.report_state === 'blind')
                          ? (_openBlock(), _createBlock("span", _hoisted_37, "숨김"))
                          : (_openBlock(), _createBlock("span", _hoisted_38, "반려"))
                    ]),
                    _createVNode("td", null, _toDisplayString(_ctx.dateTimeHelper.timestampToDateTime(
                        report.created_at,
                        'YYYY-MM-DD HH:mm',
                      )), 1)
                  ], 8, ["onClick"]))
                }), 128))
              ])
            ])
          ]),
          _createVNode("div", _hoisted_39, [
            _createVNode("button", {
              class: "btn paging-prev",
              disabled: _ctx.currentPage === 1,
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
            }, " 이전 ", 8, ["disabled"]),
            _createVNode("button", {
              class: "btn paging-next",
              disabled: _ctx.userReports.length === 0,
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
            }, " 다음 ", 8, ["disabled"])
          ])
        ])
      ], 2)
    ])
  ]))
})